export default __webpack_public_path__ + "static/media/login.1d2f7feb.svg";